<template>
  <!--
    Path B: PG&E member rows carry an Actions array embedded by the
    `GetCompanyUsers` rule. Each action has its own ruleId, label, style, and
    optional confirmation. This renderer is structurally the same as the
    company-row PgeCompaniesActionsCellRenderer - it just passes through to
    the shared rendering logic so the two stay in lockstep.
  -->
  <PgeCompaniesActionsCellRenderer :params="params" />
</template>

<script setup>
import PgeCompaniesActionsCellRenderer from '@customers/pge/components/cell-renderers/PgeCompaniesActionsCellRenderer.vue'

defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
</script>
